module.exports = __webpack_public_path__ + "img/standard-button-white.08d59f18.png";